import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Login_Page } from "../../Configuration/API_URL";
import { useState } from "react";
import warningIcon from "../../asset/images/icons/warning.svg";
import { Constants } from "../../CommonMethhods/Constants";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import Formnav from "./FormNav";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../CommonMethhods/CommonMethods";
import axiosInstance from "../../CommonMethhods/axiosInstance";
// import BackIcon from "../../asset/images/BackIcon.svg"

const ChangePasswordForm = (props) => {
  const [validUser, setValidUser] = useState(false);

  const changePassSchema = Yup.object().shape({
    OldPassValid: Yup.string().required("*Please Enter Old Password"),
    NewPassValid: Yup.string().required("*Please Enter New Password"),
    ConfirmNewValid: Yup.string().required("*Confirm New Password"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(changePassSchema),
  });

  let navigate = useNavigate();

  const changePassword = async (data) => {
    const storeToken = localStorage.getItem("ssoToken");
    let payloadValue = {
      oldPassword: data.OldPassValid,
      newPassword: data.NewPassValid,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getChangedPassword = await axiosInstance.post(
        Login_Page.Change_Password,
        `"${encPayload}"`,
      );
      const responseData = ApiResDecrypt(getChangedPassword?.data);

      if (responseData?.status === 0) {
        toast.success(responseData?.data);
        navigate("/dashboard");
      } else {
        toast.error(responseData?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function checkPasswords(data) {
    if (data.NewPassValid === data.ConfirmNewValid) {
      setValidUser(false);
      changePassword(data);
    } else {
      setValidUser(true);
    }
  }

  function showOldPass(e, mainID) {
    var oldPass = document.getElementById(mainID);
    var eyeicon = e.target;
    if (oldPass.type === "password") {
      oldPass.type = "text";
      eyeicon.className = "icon-Pass_hide";
    } else {
      oldPass.type = "password";
      eyeicon.className = "icon-Pass_see";
    }
  }

  return (
    <div className={`${props.fromLogin && "form-wrapper"}`}>
      <form
        className="form login-form login-page-form"
        onSubmit={handleSubmit(checkPasswords)}
      >
        {props.fromLogin && (
          <div className="mb-5">
            <Formnav />
          </div>
        )}

        {!props.titleChangePass ? (
          ""
        ) : (
          <h2 className="form-title">{Constants.Change_Password}</h2>
        )}

        <label htmlFor="name" className="form-label">
          {Constants.OLD_PASSWORD}
          <span className="mandatory-label">*</span>
        </label>
        <div className="password-icon">
          <input
            type="password"
            id="oldPass"
            className={`form-input ${
              errors?.OldPassValid?.message ? "border border-danger" : ""
            }`}
            placeholder="Enter Old Password"
            maxLength={20}
            autoComplete="off"
            {...register("OldPassValid")}
          />
          <div className="visible-pass">
            <span
              onClick={(e) => showOldPass(e, "oldPass")}
              className={"icon-Pass_see" ? "icon-Pass_see" : "icon-Pass_hide"}
            ></span>
          </div>
        </div>
        <p className="forget-link">
          <span>{errors?.OldPassValid?.message}</span>
        </p>

        <label htmlFor="email" className="form-label">
          {Constants.NEW_PASSWORD}
          <span className="mandatory-label">*</span>
        </label>
        <div className="password-icon">
          <input
            type="password"
            className={`form-input ${
              errors?.NewPassValid?.message ? "border border-danger" : ""
            }`}
            id="newPass"
            placeholder="Enter New Password"
            maxLength={20}
            autoComplete="off"
            {...register("NewPassValid")}
          />
          <div className="visible-pass">
            <span
              onClick={(e) => showOldPass(e, "newPass")}
              className={"icon-Pass_see" ? "icon-Pass_see" : "icon-Pass_hide"}
            ></span>
          </div>
        </div>
        <p className="forget-link">
          <span>{errors?.NewPassValid?.message}</span>
        </p>

        <label htmlFor="email" className="form-label">
          {Constants.CONFIRM_NEW_PASSWORD}
          <span className="mandatory-label">*</span>
        </label>
        <div className="password-icon">
          <input
            type="password"
            className={`form-input ${
              errors?.ConfirmNewValid?.message ? "border border-danger" : ""
            }`}
            id="confNewPass"
            placeholder="Confirm New Password"
            maxLength={20}
            autoComplete="off"
            {...register("ConfirmNewValid")}
          />
          <div className="visible-pass">
            <span
              onClick={(e) => showOldPass(e, "confNewPass")}
              id="confNewPass"
              className={"icon-Pass_see" ? "icon-Pass_see" : "icon-Pass_hide"}
            ></span>
          </div>
        </div>
        <p className="forget-link">{errors?.ConfirmNewValid?.message}</p>

        {/* <!-- submit btn --> */}
        <div className="login-form__bottom">
          {validUser && (
            <p className="forget-link">
              <img src={warningIcon} alt="warning" />
              <span>Password did not match</span>
            </p>
          )}
          <button className="form-submit" type="submit">
            {Constants.Submit}
          </button>
        </div>
        {props.fromLogin && (
          <span className="form-link justify-content-end">
            <Link to="/">Back to Login?</Link>
          </span>
        )}
      </form>
    </div>
  );
};

export default ChangePasswordForm;
